import React from "react";
import "../CSS/EI.css";
import logo from "../../assets/icone.png";
import Cookies from "js-cookie";

function EI() {
  const courses = [
    "Diploma in Supply Chain Management",
    "Diploma in Business Management",
    "Diploma in Information Technology",
    "Certificate in Hospitality Management",
    "Diploma in Public Relations",
    "Diploma in Accounting",
  ];

  const attachmentData = [
    { course: "Supply Chain Management", students: 42, placed: 36, pending: 6 },
    { course: "Business Management", students: 35, placed: 31, pending: 4 },
    { course: "Information Technology", students: 28, placed: 25, pending: 3 },
    { course: "Accounting", students: 24, placed: 20, pending: 4 },
  ];

  const internshipData = [
    { course: "Business Management", students: 30, placed: 26, pending: 4 },
    { course: "Information Technology", students: 22, placed: 19, pending: 3 },
    { course: "Public Relations", students: 18, placed: 16, pending: 2 },
    { course: "Hospitality", students: 20, placed: 17, pending: 3 },
  ];

  const jobData = [
    { category: "Sales & Marketing", applicants: 35, placed: 22 },
    { category: "ICT & Technology", applicants: 28, placed: 17 },
    { category: "Administration", applicants: 24, placed: 15 },
    { category: "Customer Service", applicants: 20, placed: 14 },
  ];

  return (
    <div className="dashboard">

      {/* SIDEBAR */}
      <aside className="sidebar">
        <div className="brand">
            <img
                          src={logo}
                          alt="Advenware Career Link"
                          className="landing-logo-image"
                        />
          
          <div>
            <h2>ADVENWARE</h2>
            <span>Career Link</span>
          </div>
        </div>

        <nav>
          <a className="active">Dashboard</a>
          <a>School Profile</a>
          <a>Courses</a>
          <a>Attachments</a>
          <a>Internships</a>
          <a>Jobs</a>
          <a>Placement Statistics</a>
          <a>Engagements</a>
        </nav>

        <div className="sidebar-footer">
          <p>School Portal</p>
          <small>Career & Placement Management</small>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="main">

        {/* HEADER */}
        <header className="topbar">
          <div>
            <p className="welcome">SCHOOL PORTAL</p>
            <h1>School Profile & Career Dashboard</h1>
          </div>

          <div className="profile">
            <div className="profile-avatar">ST</div>
            <div>
              <strong>School Administrator</strong>
              <span>Administrator</span>
            </div>
          </div>
        </header>

        {/* SCHOOL PROFILE */}
        <section className="school-profile">
          <div className="school-logo">ST</div>

          <div className="school-info">
            <span className="tag">PARTNER INSTITUTION</span>
            <h2>Thika Technical Training Institute</h2>

            <p>
              A technical and vocational education institution providing
              practical skills, professional training and career development
              opportunities to students.
            </p>

            <div className="school-details">
              <span>📍 Thika, Kenya</span>
              <span>📞 +254 700 000 000</span>
              <span>✉️ info@school.ac.ke</span>
            </div>
          </div>

          <button className="outline-btn">View Full Profile</button>
        </section>

        {/* STATISTICS */}
        <section className="stats-grid">

          <div className="stat-card blue">
            <div className="stat-icon">🎓</div>
            <div>
              <span>Courses Offered</span>
              <h2>24</h2>
              <small>Active courses</small>
            </div>
          </div>

          <div className="stat-card green">
            <div className="stat-icon">📋</div>
            <div>
              <span>Attachments</span>
              <h2>129</h2>
              <small>Students placed</small>
            </div>
          </div>

          <div className="stat-card orange">
            <div className="stat-icon">💼</div>
            <div>
              <span>Internships</span>
              <h2>78</h2>
              <small>Students placed</small>
            </div>
          </div>

          <div className="stat-card purple">
            <div className="stat-icon">🚀</div>
            <div>
              <span>Jobs</span>
              <h2>68</h2>
              <small>Students employed</small>
            </div>
          </div>

        </section>

        {/* SCHOOL INFORMATION */}
        <section className="content-grid">

          <div className="panel">
            <div className="panel-header">
              <div>
                <span className="section-label">INSTITUTION</span>
                <h2>School Profile</h2>
              </div>
              <button className="small-btn">Edit</button>
            </div>

            <div className="profile-list">
              <div>
                <span>Institution Name</span>
                <strong>Thika Technical Training Institute</strong>
              </div>

              <div>
                <span>Institution Type</span>
                <strong>Technical & Vocational Institution</strong>
              </div>

              <div>
                <span>Location</span>
                <strong>Thika, Kiambu County</strong>
              </div>

              <div>
                <span>Students</span>
                <strong>3,850</strong>
              </div>

              <div>
                <span>Partner Since</span>
                <strong>2024</strong>
              </div>

              <div>
                <span>Status</span>
                <strong className="status-active">Active Partner</strong>
              </div>
            </div>
          </div>

          {/* COURSES */}
          <div className="panel">
            <div className="panel-header">
              <div>
                <span className="section-label">ACADEMICS</span>
                <h2>Courses Offered</h2>
              </div>

              <span className="count-badge">24 Courses</span>
            </div>

            <div className="course-list">
              {courses.map((course, index) => (
                <div className="course-item" key={index}>
                  <span className="course-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span>{course}</span>

                  <span className="arrow">→</span>
                </div>
              ))}
            </div>
          </div>

        </section>

        {/* ATTACHMENT DATA */}
        <section className="panel full-panel">

          <div className="panel-header">
            <div>
              <span className="section-label">PLACEMENT SERVICES</span>
              <h2>Attachment Data</h2>
            </div>

            <button className="small-btn">View All</button>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Course</th>
                  <th>Students</th>
                  <th>Placed</th>
                  <th>Pending</th>
                  <th>Placement Rate</th>
                </tr>
              </thead>

              <tbody>
                {attachmentData.map((item, index) => {
                  const rate = Math.round(
                    (item.placed / item.students) * 100
                  );

                  return (
                    <tr key={index}>
                      <td>{item.course}</td>
                      <td>{item.students}</td>
                      <td className="green-text">{item.placed}</td>
                      <td className="orange-text">{item.pending}</td>
                      <td>
                        <div className="progress-wrapper">
                          <div className="progress">
                            <div
                              className="progress-bar"
                              style={{ width: `${rate}%` }}
                            ></div>
                          </div>
                          <span>{rate}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

        </section>

        {/* INTERNSHIP + JOBS */}
        <section className="content-grid">

          {/* INTERNSHIPS */}
          <div className="panel">

            <div className="panel-header">
              <div>
                <span className="section-label">WORK EXPERIENCE</span>
                <h2>Internship Data</h2>
              </div>

              <span className="count-badge">90+</span>
            </div>

            <div className="mini-table">

              {internshipData.map((item, index) => (
                <div className="mini-row" key={index}>
                  <div>
                    <strong>{item.course}</strong>
                    <small>{item.students} applicants</small>
                  </div>

                  <div className="mini-results">
                    <span className="success">
                      {item.placed} placed
                    </span>

                    <span className="pending">
                      {item.pending} pending
                    </span>
                  </div>
                </div>
              ))}

            </div>
          </div>

          {/* JOBS */}
          <div className="panel">

            <div className="panel-header">
              <div>
                <span className="section-label">EMPLOYMENT</span>
                <h2>Jobs Data</h2>
              </div>

              <span className="count-badge">68 Placed</span>
            </div>

            <div className="mini-table">

              {jobData.map((item, index) => (
                <div className="mini-row" key={index}>

                  <div>
                    <strong>{item.category}</strong>
                    <small>{item.applicants} applicants</small>
                  </div>

                  <div className="job-result">
                    <strong>{item.placed}</strong>
                    <small>placed</small>
                  </div>

                </div>
              ))}

            </div>
          </div>

        </section>

        {/* PLACEMENT STATISTICS */}
        <section className="panel full-panel">

          <div className="panel-header">
            <div>
              <span className="section-label">PERFORMANCE</span>
              <h2>Placement Statistics</h2>
            </div>

            <select className="year-select">
              <option>2026</option>
              <option>2025</option>
              <option>2024</option>
            </select>
          </div>

          <div className="placement-overview">

            <div className="big-stat">
              <span>Total Students Supported</span>
              <strong>275</strong>
              <small>Across all placement services</small>
            </div>

            <div className="big-stat">
              <span>Successfully Placed</span>
              <strong>233</strong>
              <small>Attachment, internship & jobs</small>
            </div>

            <div className="big-stat">
              <span>Overall Placement Rate</span>
              <strong>85%</strong>
              <small>Based on registered requests</small>
            </div>

            <div className="big-stat">
              <span>Partner Organisations</span>
              <strong>47</strong>
              <small>Active placement partners</small>
            </div>

          </div>

        </section>

        {/* OTHER ENGAGEMENTS */}
        <section className="panel full-panel">

          <div className="panel-header">
            <div>
              <span className="section-label">CAREER DEVELOPMENT</span>
              <h2>Other Engagements</h2>
            </div>
          </div>

          <div className="engagement-grid">

            <div className="engagement-card">
              <div className="engagement-icon">🎯</div>
              <div>
                <h3>Career Guidance</h3>
                <p>
                  Students receive career advice, professional direction
                  and support in making informed career decisions.
                </p>
                <strong>320 Students Engaged</strong>
              </div>
            </div>

            <div className="engagement-card">
              <div className="engagement-icon">🤝</div>
              <div>
                <h3>Mentorship</h3>
                <p>
                  Students are connected with professionals and mentors
                  for personal and career development.
                </p>
                <strong>185 Students Mentored</strong>
              </div>
            </div>

            <div className="engagement-card">
              <div className="engagement-icon">🎓</div>
              <div>
                <h3>Scholarships</h3>
                <p>
                  Students are connected to scholarship and education
                  funding opportunities.
                </p>
                <strong>42 Opportunities Shared</strong>
              </div>
            </div>

          </div>

        </section>

        {/* FOOTER */}
        <footer>
          <p>
            © 2026 Advenware Career Link — School Career & Placement Portal
          </p>

          <span>Empowering Talent. Building Careers. Transforming Futures.</span>
        </footer>

      </main>
    </div>
  );
}

export default EI;